import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EventResponseModel } from 'projects/common/igsu-models';

@Injectable({ providedIn: 'root' })
export class EventsAPI {
  private http = inject(HttpClient);

  public getInventory(patronId: number) {
    return this.http.get<EventResponseModel>(`/patrons/${patronId}/inventory`);
  }
}
